// extracted by mini-css-extract-plugin
export default {"container":"imageWithText_container__KMbMz","textOverlay":"imageWithText_textOverlay__ND8vm"};